import React, { useEffect } from 'react';
import GameDeleteFormContainer from '../../containers/GameDeleteFormContainer';

function GameDelete(props) {

    const { clearGame, getGame, match, game } = props;

    useEffect(() => {
        clearGame();
        getGame(match.params.id);
    }, [clearGame, getGame, match]);

    return <div>
        {game && game.name ?
            <GameDeleteFormContainer />
            : '....loading'}
    </div>;

}

export default GameDelete;